import { Type } from 'class-transformer';

import { RiskProfile } from 'app/shared/models/risk-profile.model';

/**
 * Model to capture Risk Profile.
 */
export class RiskProfileResponseType {
    riskProfileHistory: RiskProfile[];
    currentProfile: RiskProfile;

    @Type(() => RiskProfileResponse)
    values: RiskProfileResponse;
}

export class RiskProfileResponse {
    riskProfileHistory: RiskProfile[];
    currentProfile: RiskProfile;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/risk-profile-response.model.ts